import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class ProductCatalogsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "product_catalog", `/api/v1/product_catalogs`);
  }
}
